/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum PackageType {
  LegacyFree = 0,
  LegacyBasic = 1,
  Free = 10,
  BusinessLite = 20,
  BusinessBasic = 21,
  BusinessStandard = 22,
  BusinessLiteV2 = 24,
  BusinessBasicV2 = 25,
  BusinessStandardV2 = 26,
  BusinessPremiumV2 = 27,
  AccountingLite = 30,
  AccountingBasic = 31,
  AccountingStandard = 32,
  AccountingV2Lite = 34,
  AccountingV2Basic = 35,
  AccountingV2Standard = 36,
  AccountingV2Premium = 37,
}
